import { commonLang } from '@umu/ukit-lang';
/**
 * @description
 */

import './formTextareaResultList.scss';

import React, { Component } from 'react';
import { components } from 'common';
const { ToggleLine } = components;
import { ISectionOptionResultContent } from '@umu/umu-types';

export interface IProps {
    resultList?: ISectionOptionResultContent[];
}

// tslint:disable-next-line:no-empty-interface
export interface IState {}

export default class FormTextareaResultList<IP extends IProps, IS extends IState> extends Component<IP, IS> {
    constructor(props: IP, state: IS) {
        super(props, state);
    }

    public render() {
        return <div className="form-textarea-reault-list">{this.getOptionList()}</div>;
    }

    public getOptionList = () => {
        const { resultList } = this.props;
        if (!resultList) {
            return null;
        }

        const ret = resultList.map((item, index) => {
            return (
                <div className={`form-textarea-reault-item`} key={index}>
                    <div className="textarea-detail">
                        <ToggleLine className="textarea-detail-toggle" maxLine={5} theme="1" expandByBtn={true}>
                            <span className="num">{index + 1}.</span>
                            <span className="user-name">{item.user_name}</span>
                            {item.is_teacher ? <span className="teacher-mark">{commonLang('讲师')}</span> : null}
                            <span className="split">：</span>
                            <span className="cnt">{item.content}</span>
                        </ToggleLine>
                    </div>
                </div>
            );
        });
        return ret;
    };
}
